import React, { memo, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Divider,
  ListSubheader,
  MenuItem,
  LoadingButton,
  Icon,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
} from "investira.react.components";
import services from "../../../services";
import { VALIDATIONS } from "../../../const";
import withEnquadramentos from "../../../hoc/withEnquadramentos";
import validators from "investira.sdk/lib/utils/validators";

const EnquadramentoRegrasCopyDialog = memo((props) => {
  const { open, onClose, readData, data, enquadramentos, enquadramentoId } =
    props;

  const VALIDATION_SCHEMA = Yup.object().shape({
    origem_enquadramento_id: Yup.string().required(VALIDATIONS.REQUIRED),
  });

  const formik = useFormik({
    initialValues: {
      sobreescrever: 0,
      origem_enquadramento_id: "",
      destino_enquadramento_id: enquadramentoId,
    },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: true,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);

      const xData = {
        origem_enquadramento_id: pValues.origem_enquadramento_id,
        destino_enquadramento_id: Number(pValues.destino_enquadramento_id),
        sobrescrever: Boolean(Number(pValues.sobreescrever)),
      };

      pActions.setSubmitting(false);
      services.enquadramentos.copy(
        {
          data: xData,
        },
        (rRes) => {
          readData({ enquadramento_id: enquadramentoId });
          onClose && onClose();
        },
        (rErr) => {
          props.responseErrorHandling(rErr);
        },
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  const filterEnquadramentos = useMemo(() => {
    return enquadramentos.filter((xEnquadramento) => {
      return xEnquadramento.enquadramento_id !== Number(enquadramentoId);
    });
  }, [enquadramentos, enquadramentoId]);

  // function handleChangeRegra(_e, pValue) {
  //   formik.setFieldValue("enquadramento_regra_id", pValue?.id || "");
  // }

  useEffect(() => {}, []);

  if (validators.isEmpty(filterEnquadramentos)) {
    return null;
  }

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={onClose}
      scroll="body"
      PaperProps={{ sx: { overflow: "visible" } }}
    >
      <DialogTitle>Copiar Regras</DialogTitle>
      <DialogContent>
        <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
          <Stack gap={2} sx={{ my: 1 }}>
            <TextField
              label="Origem"
              id="origem_enquadramento_id"
              name="origem_enquadramento_id"
              variant="outlined"
              select
              value={formik.values.origem_enquadramento_id}
              onChange={formik.handleChange}
            >
              <ListSubheader>Enquadramento</ListSubheader>
              {filterEnquadramentos.map((option) => (
                <MenuItem
                  key={option.enquadramento_id}
                  value={option.enquadramento_id}
                >
                  {option.enquadramento}
                </MenuItem>
              ))}
            </TextField>
            <Divider />
            <Stack flex="1" px={2}>
              <FormControl>
                <FormLabel>Regras:</FormLabel>
                <RadioGroup
                  row
                  name="sobreescrever"
                  value={formik.values.sobreescrever}
                  onChange={formik.handleChange}
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Sobreescrever"
                  />
                  <FormControlLabel
                    value={0}
                    control={<Radio />}
                    label="Adicionar"
                  />
                </RadioGroup>
              </FormControl>
            </Stack>
          </Stack>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button onClick={onClose}>Cancelar</Button>
            <LoadingButton
              variant="contained"
              color="primary"
              startIcon={<Icon color="secondary" iconName="insert" size={16} />}
              sx={{ px: 2 }}
              type="submit"
              disabled={formik.isSubmitting || !formik.isValid}
              loading={formik.isSubmitting}
            >
              Adicionar
            </LoadingButton>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
});

export default withEnquadramentos(EnquadramentoRegrasCopyDialog);
